import { createBrowserRouter, Navigate, RouterProvider } from 'react-router';
import { AuthProvider } from './auth/context';
import { RequireAuth } from './auth/guard';
import { LoginPage } from './pages/Login';
import { HostListPage } from './pages/HostList';
import { ConnectPage } from './pages/Connect';
import { SessionPage } from './pages/Session';
import { NotFoundPage } from './pages/NotFound';
import { ToastProvider } from './components/Toast';

const router = createBrowserRouter([
  { path: '/', element: <Navigate to="/hosts" replace /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/hosts', element: <RequireAuth><HostListPage /></RequireAuth> },
  { path: '/session/new', element: <RequireAuth><ConnectPage /></RequireAuth> },
  { path: '/session/:sessionId', element: <RequireAuth><SessionPage /></RequireAuth> },
  { path: '*', element: <NotFoundPage /> },
]);

export function App() {
  return (
    <AuthProvider>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </AuthProvider>
  );
}
